import type { FormEvent } from 'react';

interface ComposerProps {
  draft: string;
  listening: boolean;
  onDraftChange(draft: string): void;
  onSend(): void;
  onToggleMic(): void;
}

export function Composer({
  draft,
  listening,
  onDraftChange,
  onSend,
  onToggleMic,
}: ComposerProps) {
  function submit(event: FormEvent) {
    event.preventDefault();
    onSend();
  }

  return (
    <form className="composer" onSubmit={submit}>
      <label className="visually-hidden" htmlFor="composer-input">
        Type English
      </label>
      <input
        id="composer-input"
        className="composer-input"
        placeholder="Type English…"
        value={draft}
        autoComplete="off"
        onChange={(event) => onDraftChange(event.target.value)}
      />
      <button
        type="button"
        className="composer-mic"
        aria-pressed={listening}
        /* The accessible name has to contain the visible "MIC" (WCAG 2.5.3). */
        aria-label={listening ? 'MIC — stop listening' : 'MIC — speak English instead of typing'}
        onClick={onToggleMic}
      >
        MIC
      </button>
      <button type="submit" className="btn-primary composer-send">
        SIGN
      </button>
    </form>
  );
}
